// frontend/src/components/onboarding/Step2Splash.js
import React from 'react';
import { Image, Alert } from 'react-bootstrap';
import { Smartphone, Image as ImageIcon, Link, Zap } from 'react-feather';

const Step2Splash = () => {
  return (
    <div className="text-center">
      <h5 className="mb-3">2. Tus imágenes en LinksEasy</h5>
      
      <div className="bg-light p-4 rounded-3 mb-4">
        <ImageIcon size={48} className="text-primary mb-3" />
        <p className="fw-bold mb-2">📸 ¿Cómo manejamos las imágenes?</p>
        
        <Alert variant="info" className="mb-3">
          <p className="mb-2">
            <strong>LinksEasy NO guarda imágenes</strong> - somos más ingeniosos que eso ✨
          </p>
        </Alert>

        <div className="row g-3 mt-3">
          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm">
              <Smartphone className="text-primary mb-2" size={24} />
              <h6 className="fw-bold">Tu avatar de Google</h6>
              <p className="small text-muted mb-0">
                Usamos la foto de tu cuenta de Google automáticamente
              </p>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm">
              <Link className="text-primary mb-2" size={24} />
              <h6 className="fw-bold">Imágenes externas</h6>
              <p className="small text-muted mb-0">
                Solo necesitas pegar el enlace (URL) de tu imagen favorita
              </p>
            </div>
          </div>
        </div>

        <div className="mt-4 p-3 bg-primary bg-opacity-10 rounded">
          <Zap size={20} className="text-primary me-2" />
          <span className="fw-bold">¿La ventaja?</span>
          <p className="small mt-2 mb-0">
            Tu perfil carga más rápido y no ocupamos espacio innecesario. 
            Las imágenes se muestran directamente desde donde están alojadas.
          </p>
        </div>
      </div>

      <div className="border-top pt-3">
        <p className="text-muted small mb-0">
          ✨ En el dashboard podrás personalizar colores, agregar más links 
          y configurar tu imagen de fondo
        </p>
      </div>
    </div>
  );
};

export default Step2Splash;